/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Typography,
  Stack,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import ContentLoader from '../../utils/errorPages/ContentLoader';
import PaymentAction from '../../store/actions/PaymentAction';

function TransactionItemView() {
  const [payInfo, setPayInfo] = useState({});
  const { code } = useParams();
  const { transItemData, isLoading } = useSelector((state) => state.payment);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(PaymentAction.getTransactionItem(code));
  }, [dispatch]);

  useEffect(() => {
    if (transItemData) {
      setPayInfo(transItemData);
    }
  }, [transItemData]);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <ContentLoader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/transaction">
            Transaction
          </Typography>
          <Typography component="h2" variant="h2">
            / View
          </Typography>
        </Stack>
      </div>
      <Card>
        <CardHeader title="Transaction Details" />
        <Grid container spacing={1}>
          <Grid item md={7} lg={7} xl={8}>
            <CardContent>
              <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Client details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Client Name</TableCell>
                        <TableCell component="td">{payInfo?.client?.name || ''}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Client Mail</TableCell>
                        <TableCell component="td">{payInfo?.customer_email || ''}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Invoice Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Invoice Number</TableCell>
                        <TableCell component="td">
                          {payInfo?.invoice?.invoice_number || ''}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Invoice Date</TableCell>
                        <TableCell component="td">{payInfo?.invoice?.invoice_date || ''}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Payment Details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">Payment Gateway</TableCell>
                        <TableCell component="td" sx={{ textTransform: 'capitalize' }}>
                          {payInfo?.payment_gateway || ''}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Transaction ID</TableCell>
                        <TableCell component="td">{payInfo?.transaction_id || ''}</TableCell>
                      </TableRow>
                      {payInfo?.card_number !== null ? (
                        <TableRow>
                          <TableCell component="th">Card Number</TableCell>
                          <TableCell component="td">{payInfo?.card_number || ''}</TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                      <TableRow>
                        <TableCell component="th">Amount</TableCell>
                        <TableCell component="td">
                          {`${payInfo?.short_name} ${payInfo?.amount || ''}`}
                        </TableCell>
                      </TableRow>
                      {payInfo?.paypal_capture_id !== null ? (
                        <TableRow>
                          <TableCell component="th">Paypal Capture ID</TableCell>
                          <TableCell component="td">{payInfo?.paypal_capture_id || ''}</TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </CardContent>
          </Grid>
          <Grid item md={5} lg={5} xl={4}>
            <CardContent sx={{ pl: '0px!important' }}>
              <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2} component="th">
                          Status details
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th">IP Address</TableCell>
                        <TableCell component="td">{payInfo?.ip_address || ''}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Paid Date</TableCell>
                        <TableCell component="td">{payInfo?._created_at}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Payment Recevied Status</TableCell>
                        <TableCell component="td">
                          {payInfo?.payment_transaction_status || ''}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th">Transaction Status</TableCell>
                        <TableCell component="td">
                          <Chip color="success" label={payInfo?.status || ''} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', p: 3 }}>
              <Button
                type="button"
                className="cancel__btn"
                // fullWidth
                sx={{ mt: 2 }}
                variant="contained"
                color="primary"
                size="medium"
                onClick={() => {
                  navigate(`/transaction`);
                }}
              >
                Back
              </Button>
            </CardActions>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
export default TransactionItemView;
